import usePrivateAxios from '@/common/api/usePrivateAxios';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { defaultTransformerResponse } from '../../constants/defaultTransformerResponse.constant';
import { Mapper } from '../../services/mapper';
import type { MetaResponse } from '../../types/metaResponse';

type UsePrinterMachineTasksProps<T> = {
  filters: {
    search?: string
    printerMachineId?: string
    page?: number
  }
  mapper?: (data: any) => T
}

export const usePrinterMachineTasks = <T,>({
  filters: { search, printerMachineId, page },
  mapper = Mapper.default<T>(),
}: UsePrinterMachineTasksProps<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    isPending,
    ...rest
  } = useQuery({
    queryKey: ['printerMachineTasks', search, printerMachineId, page],
    queryFn: () => {
      return privateAxios.get(`/printer/tasks`, {
        params: {
          search,
          'q[machine_id_eq]': printerMachineId,
          page,
        },
      })
    },
    select: (data: { data: { data: any[]; meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      }
    },
    placeholderData: keepPreviousData,
  })

  return { data, meta, isPending, ...rest }
}
